/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_No_Preset_Selected_ToastInputs */

const en_styles_no_preset_selected_toast = /** @type {(inputs: Styles_No_Preset_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No preset selected`)
};

const fr_styles_no_preset_selected_toast = /** @type {(inputs: Styles_No_Preset_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun preset selectionne`)
};

const de_styles_no_preset_selected_toast = /** @type {(inputs: Styles_No_Preset_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Voreinstellung ausgewählt`)
};

const it_styles_no_preset_selected_toast = /** @type {(inputs: Styles_No_Preset_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun preset selezionato`)
};

const ru_styles_no_preset_selected_toast = /** @type {(inputs: Styles_No_Preset_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительно заданные параметры не выбраны`)
};

const es_styles_no_preset_selected_toast = /** @type {(inputs: Styles_No_Preset_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha seleccionado ningún ajuste preestablecido`)
};

const zh_cn2_styles_no_preset_selected_toast = /** @type {(inputs: Styles_No_Preset_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择预设值`)
};

const ja_styles_no_preset_selected_toast = /** @type {(inputs: Styles_No_Preset_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットが選択されていません`)
};

const hi_styles_no_preset_selected_toast = /** @type {(inputs: Styles_No_Preset_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई पूर्व निर्धारित सेटिंग नहीं चुनी गई`)
};

const pt_pt2_styles_no_preset_selected_toast = /** @type {(inputs: Styles_No_Preset_Selected_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma predefinição selecionada`)
};

/**
* | output |
* | --- |
* | "No preset selected" |
*
* @param {Styles_No_Preset_Selected_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_no_preset_selected_toast = /** @type {((inputs?: Styles_No_Preset_Selected_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_No_Preset_Selected_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_no_preset_selected_toast(inputs)
	if (locale === "de") return de_styles_no_preset_selected_toast(inputs)
	if (locale === "it") return it_styles_no_preset_selected_toast(inputs)
	if (locale === "ru") return ru_styles_no_preset_selected_toast(inputs)
	if (locale === "es") return es_styles_no_preset_selected_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_no_preset_selected_toast(inputs)
	if (locale === "ja") return ja_styles_no_preset_selected_toast(inputs)
	if (locale === "hi") return hi_styles_no_preset_selected_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_no_preset_selected_toast(inputs)
	return en_styles_no_preset_selected_toast(inputs)
});